import React from 'react'
import clsx from 'clsx'
import MediaAvatar from '../../../atoms/MediaAvatar'
import useStyles from './styles'

interface ParticipantsProps {
  userId: number
  index: number
  numberOfParticipants: number
  allUsers: Object
  loadUser: Function
  isGroupChat: boolean
}
const Participants: React.FC<ParticipantsProps> = ({
  userId,
  index,
  numberOfParticipants,
  allUsers,
  loadUser,
  isGroupChat
}) => {
  const classes = useStyles()
  const user = allUsers[userId]

  React.useEffect(() => {
    if (!allUsers[userId]) {
      loadUser(userId)
    }
  }, [allUsers, loadUser, userId])

  return (
    <MediaAvatar
      user={user}
      showBadge
      group
      hideCard={isGroupChat}
      className={clsx(
        classes.avatar,
        index > 0 ? classes.marginLeft : '',
        index === numberOfParticipants - 1 ? '' : classes.avatarBorder
      )}
      style={{
        zIndex: numberOfParticipants - index
      }}
    />
  )
}
export default Participants
